import React from 'react';
import { Link } from 'react-router-dom';
import Road from '../Assets/Road.jpg';
import RoadMobile from '../Assets/RoadMobile.jpg';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-size: cover;
  width: 100vw;
  
  @media(min-width: 769px) {
  background-image: url("${Road}");
  min-height: 50vh;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 3rem 21%;
  }
  
  @media(max-width: 768px) {
  background-image: url("${RoadMobile}");
  min-height: 60vh;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1rem 2rem;
  }
  
  @media(max-height: 900px) and (min-width: 1024px) {
    text-align: end;
    padding: 2rem 15%;
  }
`;

const Title = styled.p`
  font-weight: bolder;

  @media(min-width: 769px) {
    font-size: 2.2rem;
  }
  
  @media(max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const StyledButton = styled.div`
  background-color: #83FCD0;
  border-radius: 10px;
  padding: 0.8rem 1.5rem ;
  font-size: 1.2rem;
  font-weight: bolder;
`;

const StyledCTALink = styled(Link)`
  color: black;
  opacity: 70%;
  z-index: 0;
  
  &:hover {
    color: black;
    opacity: 100%;
    text-decoration: none;
  }
`;

const CTASection = () => {
    return (
        <Container>
            <Title>{data.cta.title}</Title>
            <p>{data.cta.text}</p>
            <StyledButton>
                <StyledCTALink to="/signform">{data.cta.buttonText}</StyledCTALink>
            </StyledButton>
        </Container>
    );
};

export default CTASection;
